/* eslint-disable no-unused-vars */
import axios from 'axios'
import Swal from 'sweetalert2'
let bearerToken ;


export async function auth(accessToken,email) {
  authToken(accessToken);

}
  async function authToken(accessToken) {
      try {
        let response = await axios.get(process.env.VUE_APP_SEEDAPI, {
          params: {
            tenant_id: process.env.VUE_APP_TENANT_ID,
            client_id: process.env.VUE_APP_CLIENT_ID,
            grant_type: process.env.VUE_APP_GRANT_TYPE,
            client_secret: process.env.VUE_APP_CLEINT_SECRET,
            resource: process.env.VUE_APP_RESOURCES,
            // Add other parameters as needed
          },
        })

        bearerToken = response.data.data.access_token
        localStorage.setItem('BearerToken', bearerToken)
        let email = localStorage.getItem('email')
        await  validateUser(email);


      } catch (error) {
        Swal.close()

      }
    }
export async function getuserinfo(token) {
      // const url = `/data/BudgetTables/`
      const url = process.env.VUE_APP_GRAPHUSERINFO
      const config = {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      }
      try {
        let response = await axios.get(url, {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        })
        const UserInfo = JSON.stringify(response.data)

      await  validateUser(response.data.email)
        // this.validateUser('jade.gadiane@rafi.ph')
        setTimeout(() => {
          // window.location.reload()
        }, 3000);

      } catch (error) {
        Swal.close()

      }
    }

  async function validateUser(email) {
      // alert(this.bearerToken)
    // const url = `/data/BudgetTables/`

      const url =
        '/api/services/RAFIPAYIntegration/RAFIPayUserAPI/Authorization'

      // alert(localStorage.getItem('BearerToken'))
      try {
        const payload = {
          RAFIPayIntegration: {
            // "EmailAddress": "DXTLCIUser01@rafi.ph"
            EmailAddress: email,
          },
        }
        let response = await axios.post(url, payload, {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Access-Control-Allow-Origin': '*',
            Authorization: 'Bearer ' + bearerToken,
          },
        })

        if (response.data.Status == 'Success') {
          Swal.close()
          localStorage.setItem('BearerToken', bearerToken)
          localStorage.setItem('UserInfo', JSON.stringify(response.data))
          let legalEnt = localStorage.getItem('legalEnt');
          if (!legalEnt) {
            localStorage.setItem('legalEnt', response.data.DefaultLegalEntity)
          }

          // localStorage.setItem('legalEnt', response.data.DefaultLegalEntity)
          // let userInfo = {
          //   $id: '1',
          //   Status: 'Success',
          //   EmployeeID: 'ID000005606',
          //   AllowedToChangeLegalEntity: true,
          //   DefaultBusinessUnit: 'ITU',
          //   DefaultDepartment: 'ITU-GEN',
          //   DefaultProgram: '',
          //   DefaultProject: '',
          //   DefaultActivity: '',
          //   DefaultCostCenter: '',
          //   AllowedToChangeFinancialDimensions: false,
          //   UserIsAnApprover: true,
          //   DisplayName: 'Jade Ryan Trazo Gadiane',
          //   DefaultLegalEntity: 'RAFI',
          // }

          // localStorage.setItem('UserInfo', JSON.stringify(userInfo))
          // localStorage.setItem('legalEnt', userInfo.DefaultLegalEntity)
          // this.$router.push({ name: 'REQUEST FOR PAYMENT' })

        } else {
          Swal.close()
          swalMessage(
            'error',
            'Unauthorized Access',
            'You are not authorized to access this page',
          )
        }
      } catch (error) {
        Swal.close()

      }
    }

   function swalMessage(icon, title, text) {
      Swal.fire({
        icon: icon,
        title: title,
        text: text,
        // footer: '<a href="">Why do I have this issue?</a>'
      })
    }
